<template>
<div class="mapchart-div" ref="chartdiv">

</div>
</template>

<script>

import * as am4core from '@amcharts/amcharts4/core'
import * as am4maps from '@amcharts/amcharts4/maps'
import am4geodata_worldLow from '@amcharts/amcharts4-geodata/worldLow'
import am4themes_dark from '@amcharts/amcharts4/themes/dark'
import am4themes_animated from '@amcharts/amcharts4/themes/animated'

am4core.useTheme(am4themes_dark)
am4core.useTheme(am4themes_animated)

export default {
components: {

},
props: {
    mockVid: Boolean,
    locations: Array
  },
data() {
  return {
    chart: undefined
  };
},
computed: {

},
watch: {

},
methods: {
  formatAddress(gps) {
      if (gps && gps !== undefined) {
        var addressList = gps && [gps.city || '', gps.province||'', gps.country||''] || []
        var country = (gps && gps.country) || ''
        if (country === '中国' || country === '中國') {
          addressList = addressList.reverse()
        }
        return addressList.join(' ')
      }
      return ''
    }
},
created() {

},
mounted() {

    let targetSVG = 'M9,0C4.029,0,0,4.029,0,9s4.029,9,9,9s9-4.029,9-9S13.971,0,9,0z M9,15.93 c-3.83,0-6.93-3.1-6.93-6.93S5.17,2.07,9,2.07s6.93,3.1,6.93,6.93S12.83,15.93,9,15.93 M12.5,9c0,1.933-1.567,3.5-3.5,3.5S5.5,10.933,5.5,9S7.067,5.5,9,5.5 S12.5,7.067,12.5,9z'

    // Create map instance
    let chart = am4core.create(this.$refs.chartdiv, am4maps.MapChart)
    let interfaceColors = new am4core.InterfaceColorSet()

    // Set map definition
    chart.geodata = am4geodata_worldLow

    // Set projection
    chart.projection = new am4maps.projections.Mercator()

    // Add zoom control
    chart.zoomControl = new am4maps.ZoomControl()

    // Set initial zoom
    chart.homeZoomLevel = 5
    let currentLocation = this.locations[0];
    let lastLocation =
      !currentLocation.lat && !currentLocation.lon
        ? { lat: 31.41, lon: 121.48 }
        : { lat: currentLocation.lat, lon: currentLocation.lon };
    chart.homeGeoPoint = {
      latitude: lastLocation.lat,
      longitude: lastLocation.lon
    }

    // Create map polygon series
    let polygonSeries = chart.series.push(new am4maps.MapPolygonSeries())
    polygonSeries.exclude = ['AQ']
    polygonSeries.useGeodata = true
    polygonSeries.mapPolygons.template.nonScalingStroke = true
    polygonSeries.mapPolygons.template.fill = new am4core.Color({
      r: 234,
      g: 237,
      b: 239,
    });

    // Add images
    let imageSeries = chart.series.push(new am4maps.MapImageSeries())
    let imageTemplate = imageSeries.mapImages.template
    imageTemplate.tooltipText = '{title}'
    imageTemplate.nonScaling = true

    let circle = imageSeries.mapImages.template.createChild(am4core.Circle);
    circle.radius = 8;
    circle.propertyFields.fill = "color";

    let circle2 = imageSeries.mapImages.template.createChild(am4core.Circle);
    circle2.radius = 16;
    circle2.propertyFields.fill = "alphaColor";

    imageTemplate.propertyFields.latitude = 'latitude'
    imageTemplate.propertyFields.longitude = 'longitude'
    let colorSet = {
      // Farmer: "#E0301E",
      // Supplier: "#D04A02",
      // Warehouse: '#EB8C00',
      // Store: '#FFB600'
      Farmer: "#0BBCAC",
    }

    let alphaColorSet = {
      // Farmer: 'rgba(224,48,30,0.3)',
      // Supplier: 'rgba(208,74,2,0.3)',
      // Warehouse: 'rgba(235,140,0,0.3)',
      // Store: 'rgba(255,182,0,0.3)'
      Farmer: "rgba(11, 188, 172, 0.32)",
    }

    // if (this.mockVid) {
    //     this.locations = this.locations.map(item => {
    //       if (item.timestamp === 1607954775661) {
    //         item.lat = "14.8701799"
    //         item.lon = "120.9841384"
    //         item.address = "Manila, Philippines"
    //         item.country = "Philippines"
    //         item.city = "Manila" 
    //       }
    //       return item
    //     })
    // }
    // console.log("mockvid", this.mockVid)
    console.log("locations", this.locations)
    
    imageSeries.data = this.locations.map(location=>{
      
      let type = location.type
      let address = this.formatAddress(location)
      let title = location.sendingorg || location.receivingorg || address;
      // let color = colorSet[location.type]
      // let alphaColor = alphaColorSet[location.type]
      let color = colorSet["Farmer"];
      let alphaColor = alphaColorSet["Farmer"];
      return {
        'svgPath': targetSVG,
        'title': title,
        'background-color': '#ffffff',
        'latitude': parseFloat(location.lat),
        'longitude': parseFloat(location.lon),
        'scale': 1,
        'color': color,
        'alphaColor': alphaColor
      }
    })

    let cities = chart.series.push(new am4maps.MapImageSeries());
    cities.mapImages.template.nonScaling = true;

    function addCity(coords, title) {
      let city = cities.mapImages.create();
      city.latitude = coords.latitude;
      city.longitude = coords.longitude;
      city.tooltipText = title;
      city.alwaysShowTooltip = true;
      city.fill = am4core.color("#0BBCAC", 0.1);
      return city;
    }

    let address = this.formatAddress(currentLocation)
    // !currentLocation.country && !currentLocation.city
    //     ? currentLocation.address.length > 10
    //       ? currentLocation.address.substr(0, 10) + "..."
    //       : currentLocation.address
    //     : currentLocation.city
    addCity(
      { latitude: currentLocation.lat, longitude: currentLocation.lon }, address
    );

    this.chart = chart;
    
  },
}
</script>
<style lang='scss' scoped>
.mapchart-div {
  width: 100%;
  height: 100%;
  max-width: 622px;
  max-height: 304px;
  background-color: #d8d8d8;
  // border-radius: 10px;
  margin: auto;
}
</style>